import React, { Component } from 'react';
import { connect } from 'react-redux';

// 👏
import { concat, debounce, each, filter, memoize, flatten, includes, isEqual, map, pullAt, split, trim, uniqWith, _last } from 'lodash'; //prettier-ignore
import _ from 'lodash';

import { SearchService } from 'services/SearchService';
import { Storage } from 'services/storage';
import { getNextBidData } from 'services/util';

import { history } from 'util/history';
import { getPathname, hasKey, isArray, isBoolean, isEmpty, isNotEmpty, isString } from 'util/utils';

import { COMPOSITE_FILTER_TYPES } from 'constants/search.const';
import { STAGE_KEYS } from 'constants/stage.const';

import {
  handleSearch,
  getSearchList,
  handleSavedSearch,
  handleMatchPair,
  handleSelectSearch,
  getCount,
  SEARCH_PAGES,
  getNewArr,
} from './APIFunctions';

import { resetDiamondSearch, modifyDiamondSearch } from '../appRedux/actions/Common';
import { LISTINGPAGES, getPath } from '../components/DiamondList/DiamondListFunctions';
import DiamondSearchComponent from '../components/DiamondSearch';
import OpenNotification from '../components/common/CommonButton/OpenNotification';
import { diatrack } from 'util/diatrack';

class DiamondSearch extends Component {
  state = { ...this.defaultState };

  get searchId() {
    return this.props.match?.params?.id;
  }

  get defaultState() {
    return {
      diamParams: {},
      selectedMaster: { isFcCol: false },
      or: [],
      threeEX: false,
      threeVGPlus: false,
      threeVG: false,
      selectedClrGrps: [],
      selectedClarGrps: [],
      clrSwitch: true,
      claritySwitch: true,
      showSavedSearch: false,
      searchTitle: '',
      searchList: [],
      stoneIds: '',
      showDemand: false,
      noBGM: false,
      brown: false,
      milky: false,
      eyeCln: false,
      newArr: false,
      searchId: '',
      loader: false,
      mixTint: false,
      certis: [],
      bidDiamond: '',
      stoneArray: [],
    };
  }

  get searchFilter() {
    const filter = SearchService.getSearchFilter(this.state.selectedMaster);

    if (LISTINGPAGES.SEARCH_DIAMOND === getPathname()) {
      const bidStoneStatus = JSON.parse(localStorage.getItem('getNextBidStatus') ?? '[]');
      filter.wSts = bidStoneStatus;
    }

    return filter;
  }

  get searchFilterLength() {
    return SearchService.getSearchFilterLength(this.searchFilter);
  }

  get compositeFilterState() {
    return SearchService.getCompositeFilterState();
  }

  static getDerivedStateFromProps(props, state) {
    const compositeFilterState = SearchService.getCompositeFilterState(Storage.get('dn-master', false));

    Object.values(COMPOSITE_FILTER_TYPES).forEach((filterKey) => {
      const selected = Object.entries(compositeFilterState[filterKey]).every(([key, value]) => {
        if (isArray(value)) value = value.sort();
        if (isArray(state.selectedMaster[key])) state.selectedMaster[key] = state.selectedMaster[key].sort();
        return JSON.stringify(state.selectedMaster[key]) === JSON.stringify(value);
      });
      if (state[filterKey] !== selected) state[filterKey] = selected;
    });

    state.newArr = Boolean(state.selectedMaster?.wSts?.includes?.(''));

    return { ...state };
  }

  handleCompositeFilter = memoize((filterKey) => () => {
    const selectedMaster = { ...this.state.selectedMaster };
    const select = !this.state[filterKey];

    Object.entries(this.compositeFilterState[filterKey]).forEach(([key, value]) => {
      selectedMaster[key] = select ? value : [];
    });

    this.setState({ selectedMaster });
  });

  componentDidMount() {
    this.setSearch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location !== this.props.location) {
      this.setState({ ...this.defaultState }, () => this.setSearch());
    }
    if (prevState.selectedMaster !== this.state.selectedMaster || prevState.or !== this.state.or) {
      this.getStoneCount();
    }
  }

  // reckless change // 👏 👏 👏 👏 👏
  notAcceptable_getCount = debounce(() => {
    //if (this.searchFilterLength < 2) return this.setState({ count: 0, loader: false });
    return new Promise((resolve) => {
      const path = `${split(window.location.pathname, '/')[1]}`;
      let apiObj = {
        ...this.searchFilter,
        //wSts: ["A", "B", "H"]
      };
      if (LISTINGPAGES.SEARCH_DIAMOND === path) {
        const getNextBidStatus = JSON.parse(localStorage.getItem('getNextBidStatus'));
        apiObj = {
          ...apiObj,
          wSts: getNextBidStatus,
        };
      }
      const obj = {
        ...apiObj,
      };
      getCount(obj, (count) => {
        this.setState(
          ({ selectedMaster }) => {
            if (!isBoolean(selectedMaster.isFcCol)) selectedMaster.isFcCol = false;
            return { selectedMaster, count, loader: false };
          },
          () => resolve(),
        );
      });
    });
  }, 120);

  getStoneCount = debounce(() => {
    // if (this.searchFilterLength < 2) return this.setState({ count: 0, loader: false });
    return new Promise((resolve) => {
      const func = this.state.selectedMaster.wSts?.includes?.('') ? getNewArr : getCount;
      func(this.searchFilter, (count) => this.setState({ count, loader: false }, () => resolve()));
    });
  }, 120);

  setSearch = async () => {
    await this.setState({ bidDiamond: '' });
    this.setState({ loader: true });
    this.setMaster();
    const path = `${split(window.location.pathname, '/')[1]}`;
    getSearchList((list) => {
      if (!isEmpty(list)) this.setState({ searchList: list });
    });

    if (!isEmpty(this.searchId)) {
      handleSelectSearch(this.searchId, (searchData, name, type) => {
        if (!isEmpty(searchData)) {
          type === 2 && this.setState({ searchTitle: name, searchId: this.searchId });
          this.handleAfterSelectSearch(searchData);
        }
      });
    } else {
      const selectedMaster = { ...this.state.selectedMaster };
      selectedMaster.isFcCol = selectedMaster.isFcCol ?? false;
      const clrSwitch = !selectedMaster.isFcCol;
      this.setState({ selectedMaster, clrSwitch, selectedClrGrps: [] });
      if (path === LISTINGPAGES.SEARCH_DIAMOND) {
        const nextBid = await getNextBidData()
          .then()
          .catch((err) => undefined);
        this.setState({ bidDiamond: nextBid ? nextBid : {} });
        const getNextBidStatus = nextBid?.sub_types?.allowDiamondFilterWSts ?? [];
        localStorage.setItem('getNextBidStatus', JSON.stringify(getNextBidStatus));
        localStorage.setItem('subTypeCode', nextBid?.sub_types?.subTypeCode);
      }
    }
  };

  setMaster = () => {
    const masterData = Storage.get('master', false);
    const diamParams = { ...this.state.diamParams };
    if (masterData) {
      diamParams.shp = masterData.SHAPE;
      diamParams.carat = masterData.SIZE;
      diamParams.col = masterData.COLOR;
      diamParams.fcCol = masterData.FANCY_COLOR;
      diamParams.clr = masterData.CLARITY;
      diamParams.flu = masterData.FLUORESCENCE;
      diamParams.shd = masterData.SHADE;
      diamParams.lb = masterData.LAB;
      diamParams.cut = masterData.CUT;
      diamParams.pol = masterData.POLISH;
      diamParams.sym = masterData.SYMMETRY;
      diamParams.hA = masterData.H_AND_A;
      diamParams.cult = masterData.CULET;
      diamParams.opInc = masterData.OPEN_INCLUSION;
      diamParams.opPav = masterData.OPEN_PAVILION;
      diamParams.opCrwn = masterData.OPEN_CROWN;
      diamParams.grdl = masterData.GIRDLE;
      diamParams.keyToSymbol = masterData.KEY_TO_SYMBOLS;
      diamParams.loc = masterData.LOCATION;
      diamParams.inten = masterData.INTENSITY;
      diamParams.ovrtn = masterData.OVERTONE;
      diamParams.mlk = masterData.MILKEY;
      diamParams.eCln = masterData.EYECLEAN;
      diamParams.mixTint = masterData.MIX_TINT;
      diamParams.blkInc = masterData.BLACK_INCLUSION;
      diamParams.wIncl = masterData.WHITE_INCLUSION;
      diamParams.whtInc = masterData.WHITE_INCLUSION_TABLE;
      diamParams.natural = masterData.NATURAL;
    }
    this.setState({ diamParams });
  };

  handleSelection = (selValues, checked, keyToSend, stoneId, rptrue) => {
    this.setState({ certis: stoneId, loader: true });
    const selectedMaster = { ...this.state.selectedMaster };

    if (rptrue) {
      selectedMaster.or = !isEmpty(stoneId)
        ? [...[{ stoneId }, { rptNo: stoneId }, { vStnId: stoneId }]]
        : isArray(selectedMaster.or)
          ? selectedMaster.or.filter((item) => !(item.stoneId || item.vStnId || item.rptNo))
          : [];
    } else {
      if (isEmpty(selValues)) {
        each(this.state.diamParams[keyToSend], (data) => {
          selectedMaster[keyToSend] = concat(selectedMaster[keyToSend] ?? [], data.id);
        });
      } else {
        selectedMaster[keyToSend] = concat(selectedMaster[keyToSend] ?? [], selValues);
      }
    }

    if (!checked) {
      selectedMaster[keyToSend] = filter(this.state.selectedMaster[keyToSend], (val) => selValues.indexOf(val) === -1);
    }

    selectedMaster.or = isArray(selectedMaster.or) ? selectedMaster.or.filter(isNotEmpty) : [];
    this.setState({ selectedMaster });
  };

  selectedCarat = (selected, params) => {
    const selectedMaster = { ...this.state.selectedMaster };
    let or = isArray(selectedMaster.or) ? [...selectedMaster.or] : [];

    const addToList = (rangeStr) => {
      const [first, last] = isString(rangeStr) ? rangeStr.split('-') : Array(2).fill(undefined);
      if (isEmpty(first) || isEmpty(last)) return;
      or.push({ crt: { '>=': first, '<=': last } });
      or = uniqWith(or, isEqual);
    };

    const filterList = (rangeStr) => {
      const [first, last] = isString(rangeStr) ? rangeStr.split('-') : Array(2).fill(undefined);
      if (isEmpty(first) || isEmpty(last)) return;
      or = or.filter((filter) =>
        hasKey(filter, 'crt') ? filter.crt['>='] !== first || filter.crt['<='] !== last : true,
      );
    };

    if (isArray(selected)) {
      isString(params) ? filterList(params) : selected.forEach(addToList);
    } else if (isArray(selected?.[params?.key])) {
      selected[params?.key].forEach((range) => (params?.checked ? addToList(range) : filterList(range)));
    }

    selectedMaster.or = or.filter(isNotEmpty);
    this.setState({ selectedMaster, or });
  };

  selectedKeyToSymbol = ({ key, list, checked }) => {
    const selectedMaster = { ...this.state.selectedMaster };
    selectedMaster.kToSArr = { [key]: [...(selectedMaster?.kToSArr?.[key] ?? [])] };

    selectedMaster.kToSArr[key] = checked
      ? selectedMaster.kToSArr[key].filter((id) => !list.includes(id))
      : [...selectedMaster.kToSArr[key], ...list];

    this.setState({ selectedMaster, loader: true });
  };

  selectedRange = (From, To, master) => {
    this.setState({ loader: true });

    const selectedMaster = { ...this.state.selectedMaster };
    if (From === '' && To === '') {
      delete selectedMaster[master];
    } else {
      Object.assign(selectedMaster, {
        [master]: { '>=': From, '<=': To },
      });
    }

    this.setState({ selectedMaster });
  };

  handleClrSwitch = () => {
    this.setState({ loader: true });

    const selectedMaster = { ...this.state.selectedMaster };
    selectedMaster['col'] = [];
    selectedMaster['fcCol'] = [];
    selectedMaster.isFcCol = Boolean(this.state.clrSwitch);

    this.setState({ selectedMaster, selectedClrGrps: [], clrSwitch: !this.state.clrSwitch });
  };

  getMaster = (key) => {
    const { diamParams } = this.state;
    const tempArray = [];
    if (diamParams[key]) {
      diamParams[key].forEach((d) => {
        each(d.id, (id) => {
          tempArray.push(id);
        });
      });
    }
    this.handleSelection(tempArray, true, key, '', '', true);
  };

  handleRefresh = () => {
    this.props.resetDiamondSearch({ searchReset: true });
    this.setState(this.defaultState, () => {
      this.setSearch();
    });
    if (getPath() === LISTINGPAGES.SEARCH_DIAMOND) {
      history.push(`/${LISTINGPAGES.SEARCH_DIAMOND}`);
    } else {
      history.push(`/${LISTINGPAGES.SEARCH}`);
    }
  };

  handleLocationChange = (val) => {
    const selectedMaster = { ...this.state.selectedMaster };
    selectedMaster['loc'] = flatten(val);
    this.setState({ selectedMaster });
  };

  handleSetStoneIds = () => {
    const selectedMaster = { ...this.state.selectedMaster };
    const or = [];
    let arr = this.state.stoneIds.includes(',')
      ? split(this.state.stoneIds, ',')
      : this.state.stoneIds.includes(' ')
        ? split(this.state.stoneIds, ' ')
        : this.state.stoneIds;

    arr = isArray(arr) ? arr.map((a) => trim(a)) : [this.state.stoneIds];

    each(arr, (a, i) => {
      if (a === '' || isEmpty(a) || a === ' ') pullAt(arr, [i]);
    });
    arr.length && or.push({ vStnId: arr });
    arr.length && or.push({ rptNo: arr });

    selectedMaster['or'] = or.filter(isNotEmpty);
    this.setState({ selectedMaster });
  };

  handleChange = (key, value) => {
    this.setState({ [key]: value });
  };

  handleAfterSelectSearch = (selection) => {
    const stoneIds = [];

    selection.or = selection.and
      ? selection.and
        .map(({ or }) => or)
        .filter(isNotEmpty)
        .reduce((p = [], c) => [...p, ...c])
      : selection?.or;

    selection.or = selection?.or ?? [];
    selection.and = undefined;

    if (isArray(selection.or)) {
      const stageKeys = Object.values(STAGE_KEYS);

      selection.or.forEach((filter, index) => {
        if (isArray(filter.stoneId)) filter.stoneId.forEach((id) => !stoneIds.includes(id) && stoneIds.push(id));
        if (isArray(filter.vStnId)) filter.vStnId.forEach((id) => !stoneIds.includes(id) && stoneIds.push(id));
        if (isArray(filter.rptNo)) filter.rptNo.forEach((id) => !stoneIds.includes(id) && stoneIds.push(id));

        const keys = Object.keys(filter).filter((key) => stageKeys.includes(key));
        keys.forEach((key) => delete selection?.or?.[index]?.[key]);
      });

      selection.or = selection.or.filter(isNotEmpty);
    }

    if (!isEmpty(stoneIds)) this.setState({ stoneArray: stoneIds });

    selection.isFcCol = selection.isFcCol ?? false;
    delete selection['isFm'];

    this.props.modifyDiamondSearch({ modifyData: selection });
    this.setState({ selectedMaster: selection, clrSwitch: !selection.isFcCol });
  };

  handleReverseState = (state) => {
    const selectedMaster = { ...this.state.selectedMaster };
    selectedMaster.wSts = this.state.newArr ? ['B'] : undefined;
    this.setState({ [state]: !this.state[state], selectedMaster });
  };

  toggleNewArrival = () => {
    this.setState((state) => {
      const selectedMaster = { ...state.selectedMaster };
      selectedMaster.wSts = selectedMaster.wSts ?? [];
      const index = selectedMaster.wSts.findIndex((wSts) => wSts === '');
      index > -1 ? selectedMaster.wSts.splice(index, 1) : selectedMaster.wSts.push('');
      selectedMaster.wSts = [...selectedMaster.wSts];
      return { selectedMaster };
    });
  };

  handleNoBGM = (checked) => {
    const diamParams = { ...this.state.diamParams };
    const selectedMaster = { ...this.state.selectedMaster };

    const fltr = { shd: ['WH', 'YL', 'NONE'], mlk: ['NONE'], mixTint: ['NONE'] };
    if (checked) {
      Object.keys(fltr).forEach((k) => {
        let ids = [];
        diamParams[k].forEach((d2) => {
          if (includes(fltr[k], d2.code)) ids = concat(ids, d2.id);
        });
        selectedMaster[k] = ids;
      });
      selectedMaster['excludeFilter'] = { noBGM: true };
    } else {
      Object.keys(fltr).forEach((d1) => {
        selectedMaster[d1] = [];
      });
      delete selectedMaster['excludeFilter'];
    }

    this.setState({ selectedMaster, noBGM: !this.state.noBGM, milky: false, mixTint: false, brown: false });
  };

  handleMatchPair = () => {
    this.setState({ loader: true });
    handleMatchPair(this.state.selectedMaster, (id) => id && this.props.history.push('/match-pair?' + id));
  };

  masterToText = (k) => {
    const values = this.searchFilter[k];
    return values?.map(v => this.state.diamParams[k].find(x => x.id.includes(v)).name);
  }

  handleSearch = () => {
    const path = `${split(window.location.pathname, '/')[1]}`;
    const sizeMins = this.searchFilter.or && this.searchFilter.or.filter(x => x.crt).map(x => x.crt['>=']);
    const sizeMaxs = this.searchFilter.or && this.searchFilter.or.filter(x => x.crt).map(x => x.crt['<=']);
    const parameters = {
      shape: this.masterToText('shp'),
      color: this.masterToText('col'),
      clarity: this.masterToText('clr'),
      cut: this.masterToText('cut'),
      polish: this.masterToText('pol'),
      symmetry: this.masterToText('sym'),
      fluorescence: this.masterToText('flu'),
      lab: this.masterToText('lb'),
      from_size: sizeMins?.length ? Math.min(...sizeMins) : null,
      to_size: sizeMaxs?.length ? Math.max(...sizeMaxs) : null,
      type: [this.props.commonData.labGrown == 'Y' ? 'LGD' : 'ND'],
    }
    const form = new FormData();
    form.append("parameters", JSON.stringify(parameters));
    form.append("event_type", "search");
    diatrack(form);
    if (this.searchFilterLength >= 2 || `/${path}` === SEARCH_PAGES['BIT_IT']) {
      handleSearch(this.searchFilter, this.state.newArr, (cb) => {
        if (cb.NOSTONE === 'NOSTONE') {
          this.setState({ showDemand: true });
        } else if (LISTINGPAGES.SEARCH_DIAMOND === path) {
          this.props.history.push(`/${LISTINGPAGES.BID}?${cb.id}`);
          return;
        } else {
          this.props.history.push(`/${LISTINGPAGES.LIST}?` + cb.id);
        }
      });
    } else {
      let stoneId = false;
      if (Object.keys(this.searchFilter).includes('or')) {
        if (this.searchFilter.or && this.searchFilter.or.length !== 0) {
          this.searchFilter.or.forEach((m) => {
            if (m.vStnId) stoneId = true;
          });
          if (stoneId) {
            handleSearch(this.searchFilter, this.state.newArr, (cb) => {
              if (cb.NOSTONE === 'NOSTONE') {
                this.setState({ showDemand: true });
              } else if (LISTINGPAGES.SEARCH_DIAMOND === path) {
                this.props.history.push(`/${LISTINGPAGES.BID}?${cb.id}`);
                return;
              } else {
                this.props.history.push(`/${LISTINGPAGES.LIST}?` + cb.id);
              }
            });
          } else {
            OpenNotification({ type: 'error', title: 'Please select any 2 criteria.' });
          }
        } else {
          OpenNotification({ type: 'error', title: 'Please select any 2 criteria.' });
        }
      } else {
        OpenNotification({ type: 'error', title: 'Please select any 2 criteria.' });
      }
    }
  };

  handleSavedSearch = () => {
    if (this.searchFilterLength >= 2) {
      handleSavedSearch(this.state.selectedMaster, this.state.searchTitle, this.state.searchId, (id) => {
        if (id) {
          this.setState({ showSavedSearch: false, searchId: '' });
          this.props.history.push(`/${LISTINGPAGES.LIST}?${id}`);
        }
      });
      return;
    }

    if (Object.keys(this.state.selectedMaster).includes('or')) {
      if (this.state.selectedMaster.or && this.state.selectedMaster.or.length !== 0) {
        const stoneId = this.state.selectedMaster.or.some((m) => isNotEmpty(m.vStnId));
        if (stoneId) {
          handleSavedSearch(this.state.selectedMaster, this.state.searchTitle, this.state.searchId, (id) => {
            if (id) {
              this.setState({ showSavedSearch: false, searchId: '' });
              this.props.history.push(`/${LISTINGPAGES.LIST}?${id}`);
            }
          });
          return;
        }
      }
    }

    OpenNotification({ type: 'error', title: 'Please select any 2 criteria.' });
  };

  render() {
    const permission = this.props.commonData.pagePermission()['searchDiamond'];

    return (
      <DiamondSearchComponent
        {...this.state}
        permission={permission}
        handleSelection={this.handleSelection}
        selectedCaratFn={this.selectedCarat}
        handleSearch={this.handleSearch}
        handleSavedSearch={this.handleSavedSearch}
        handleMatchPair={this.handleMatchPair}
        selectedMaster={this.state.selectedMaster}
        handleClrSwitch={this.handleClrSwitch}
        selectedKeyToSymbol={this.selectedKeyToSymbol}
        selectedRange={this.selectedRange}
        handleCompositeFilter={this.handleCompositeFilter}
        handleRefresh={this.handleRefresh}
        handleLocationChange={this.handleLocationChange}
        handleChange={this.handleChange}
        handleSetStoneIds={this.handleSetStoneIds}
        handleAfterSelectSearch={this.handleAfterSelectSearch}
        isFancy={split(window.location.pathname, '/')[1] === LISTINGPAGES.FANCY_SEARCH}
        handleReverseState={this.handleReverseState}
        handleNoBGM={this.handleNoBGM}
        toggleNewArrival={this.toggleNewArrival}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  commonData: state?.commonData,
});

export default connect(mapStateToProps, {
  resetDiamondSearch,
  modifyDiamondSearch,
})(DiamondSearch);
